module.exports = __webpack_public_path__ + "img/227.dishwashing.416e4b96.svg";